export enum MissionGlobalType {
  SIMULATION       = 1,
  COVERAGE         = 2,
  FORMATION        = 3
}